<div class="maintain-form">
  @if (menuCofig) {
    <h2 class="title">
      <button mat-icon-button color="primary" (click)="navigateToTable()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <span>{{ getTitle() }}</span>
      @if (!loading && isEditable() && !shouldDisplayId()) {
        <button color="accent" mat-mini-fab class="submit-button" (click)="submit()" type="submit">
          <mat-icon>add</mat-icon>
        </button>
      }
      @if (!loading && isEditable() && shouldDisplayId()) {
        <button color="accent" mat-mini-fab class="submit-button" (click)="submit()" type="submit">
          <mat-icon>save</mat-icon>
        </button>
      }
      @if (!loading && !isEditable()) {
        <app-maintain-table-row-actions
          class="edit-button"
          [data]="data"
          [id]="id"
          [code]="code"
          [detailsMode]="true"
          [menuConf]="menuCofig"></app-maintain-table-row-actions>
      }
    </h2>
  }
  <mat-card>
    @if (!loading && !hasError) {
      <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <div class="form-mat-card">
          <table class="table-container">
            @if (shouldDisplayId()) {
              <tr class="disabled">
                <td>Id</td>
                <td class="info-item">{{ data.id }}</td>
              </tr>
            }
            @for (field of fieldsToDisplay; track field) {
              @if (!isPanel(field.type)) {
                <tr [ngClass]="{ disabled: field.editReadOnly }">
                  <td>{{ field.label }}</td>
                  <td>
                    <app-form-field
                      [type]="field.type"
                      [data]="getDataForFormField(field)"
                      [fieldConfig]="field"
                      [editMode]="isEditable()"
                      [formGroup]="formGroup"
                      [rowData]="data"></app-form-field>
                  </td>
                </tr>
              }
              @if (isPanel(field.type)) {
                <tr [ngClass]="{ disabled: field.editReadOnly }">
                  <td colspan="2">
                    <app-form-field
                      [type]="field.type"
                      [data]="getDataForFormField(field)"
                      [fieldConfig]="field"
                      [editMode]="isEditable()"
                      [formGroup]="formGroup"
                      [rowData]="data"></app-form-field>
                  </td>
                </tr>
              }
            }
          </table>
        </div>
      </form>
    }
  </mat-card>
  @if (!loading && hasError) {
    <app-not-found [code]="hasError"></app-not-found>
  }
</div>
@if (loading) {
  <div class="spinner-info">
    <mat-spinner [diameter]="36"></mat-spinner>
  </div>
}
